<div
  class="max-w-[464px] max-sm:w-[310px] w-full bg-white rounded-10 shadow-share dark:shadow-share-dark relative p-6 max-sm:p-4 z-10"
>
  <img
    alt="close"
    [src]="urlIcon + 'close.svg'"
    class="cursor-pointer absolute right-5 max-sm:right-3 max-sm:w-[12px]"
    (click)="$event.stopPropagation(); closeModal()"
  />
  <div class="text-black-3 text-24 max-sm:text-16 font-roboto-500">
    {{
      onlyShowToritoPage()
        ? ("Sharethislotery" | translate)
        : ("Sharethismatch" | translate)
    }}
  </div>
  <div class="text-black-4 text-14 max-sm:text-12 font-roboto-400">
    {{ "Sharedescription" | translate }}
  </div>
  <div class="flex justify-between gap-3 max-sm:gap-1 my-4">
    <img
      alt="facebook"
      [src]="urlIcon + 'facebook.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('facebook')"
    />
    <!-- <img
      alt="gmail"
      [src]="urlIcon + 'email.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('email')"
    /> -->
    <img
      alt="twitter"
      [src]="urlIcon + 'twitter.png'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('twitter')"
    />
    <!-- <img
      alt="google"
      [src]="urlIcon + 'google.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('google')"
    />
    <img
      alt="linkedin"
      [src]="urlIcon + 'linkedin.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('linkedin')"
    />
    <img
      alt="pinterest"
      [src]="urlIcon + 'pinterest.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('pinterest')"
    /> -->
    <img
      alt="instagram"
      [src]="urlIcon + 'instagram.png'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('instagram')"
    />
    <img
      alt="whatsapp"
      [src]="urlIcon + 'whatsapp.png'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('whatsapp')"
    />
    <img
      alt="telegram"
      [src]="urlIcon + 'telegram.svg'"
      class="cursor-pointer w-[48px] max-sm:w-[37px]"
      (click)="shareOnPlatform('telegram')"
    />
  </div>
  <div
    class="flex justify-between gap-2 w-full border border-grey-13 p-3 max-sm:p-2 rounded-[4px] text-14 max-sm:text-12 font-roboto-400 text-grey-14"
  >
    <span class="overflow-clip text-clip w-100minus22">{{ link }}</span>
    <img
      alt="copy"
      [src]="urlIcon + (isCopied ? 'check.svg' : 'copy.svg')"
      class="cursor-pointer max-sm:w-[16px]"
      (click)="copy()"
    />
  </div>
</div>
